import { TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const NumberInputField: React.FunctionComponent<{
  label: string,
  value?: number;
  readOnly?: boolean;
  maxWidth?: number;
  testId?: string;
  onChange: (value: number) => void;
}> = (props) => {
  const ref = useRef<HTMLInputElement>();

  const formatValue = (value: number | string | null | undefined) => {
    return parseInt((value == null ? "0" : value.toString())).toString();
  }


  const [value, setValue] = useState<string>(formatValue(props.value));

  useEffect(() => {
    setValue(formatValue(props.value));
  }, [props.value]);

  return (
    <TextField
      data-testid={props.testId}
      inputRef={ref}
      type="number"
      size="small"
      disabled={props.readOnly}
      label={props.label}
      variant="outlined"
      style={
        { maxWidth: props.maxWidth }
      }
      value={value}

      InputLabelProps={{
        shrink: true,
      }}
      onChange={(e) => {
        const v = e.target.value.replace("+", "");
        setValue(v);
      }}
      onBlur={(e) => {
        const v = e.target.value.replace("+", "");

        const val = parseFloat(v);
        if (isNaN(val)) {
          if (ref.current) {
            ref.current.value = props.value == null ? "0" : props.value.toString();
          }
          return;
        }
        setValue(v);
        props.onChange(val);
      }}
    />
  );
}

export default NumberInputField;